import DOMPurify from "dompurify";

// Centralized HTML sanitizer for any user-supplied / network-fetched HTML
// rendered via dangerouslySetInnerHTML. Strips <script>, on* handlers,
// javascript: URIs, etc. Email-safe tag/attribute allow-list keeps common
// formatting (paragraphs, lists, links, blockquotes) but blocks anything
// that could execute code.
const EMAIL_CONFIG = {
  ALLOWED_TAGS: [
    "a", "b", "br", "blockquote", "code", "div", "em", "h1", "h2", "h3", "h4",
    "h5", "h6", "i", "img", "li", "ol", "p", "pre", "span", "strong", "sub",
    "sup", "table", "tbody", "td", "th", "thead", "tr", "u", "ul",
  ],
  ALLOWED_ATTR: ["href", "title", "alt", "src", "style", "target", "rel"],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|cid|data:image\/(?:png|jpe?g|gif|webp)):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
};

export function sanitizeHtml(html) {
  if (html === undefined || html === null) return "";
  return DOMPurify.sanitize(String(html), EMAIL_CONFIG);
}
